import React, { useCallback } from 'react';
import { formatTranslation } from 'intl';
import { useIntl } from 'react-intl';
import { downloadFile } from 'services/fileOperations';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { DownloadIcon } from '../icons';
import { ActionButton } from './actionButton';
import { showGenericErrorToast } from 'services/toaster';
import { getFileDisplayName, signedRequestService } from 'services/fileService';
import { IssueTranslationKeys } from 'intl/keys';

interface DownloadButtonProps {
  idx: number;
  isMobile: boolean;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  idx,
  isMobile,
}) => {
  const intl = useIntl();
  const [file] =
    useGalleryContext().useMainDisplayedFile(identitySelector);
  const { drawings } = useGalleryContext();

  const DOWNLOAD = formatTranslation(intl, IssueTranslationKeys.previewGalleryFileDownloadLabel,);

  const handleDownload = useCallback((): void => {
    if (!file) return;
    const filename = getFileDisplayName(file, 'file');
    const source = signedRequestService.resolveGalleryDownloadSource(
      file,
      drawings[idx]?.mergedImageUrl
    );
    downloadFile(
      source,
      filename,
      file.data?.extension
    ).catch(() => showGenericErrorToast());
  }, [file, drawings, idx]);

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={handleDownload}
      disabled={false}
      tooltipTitle={DOWNLOAD}
      label={DOWNLOAD}
      icon={<DownloadIcon />}
    />
  );
};
